import { IBarrier, IBowtie, IDiagram } from 'plugin-codaf-risk-ext-bowtie/types'

import { BOWTIE_BASE_URL, BOWTIE_REST_ENDPOINTS } from '../utils/constants'

export const importRiskDiagramData = async (body: File): Promise<void> => {
    const formData = new FormData()
    formData.append('file', body)

    return fetch(`${BOWTIE_BASE_URL}/${BOWTIE_REST_ENDPOINTS.riskDiagramImport}/`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {},
        body: formData
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })
}

export const importBarrierData = async (body: File): Promise<void> => {
    const formData = new FormData()
    formData.append('file', body)

    return fetch(`${BOWTIE_BASE_URL}/${BOWTIE_REST_ENDPOINTS.barrierImport}/`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {},
        body: formData
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })
}

export const associateBowtieData = async (body: File): Promise<void> => {
    const formData = new FormData()
    formData.append('file', body)

    return fetch(`${BOWTIE_BASE_URL}/${BOWTIE_REST_ENDPOINTS.bowtieAssociation}/`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {},
        body: formData
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })
}

export const getImportBowtieStatus = async (): Promise<{ message: string }> => {
    return fetch(`${BOWTIE_BASE_URL}/${BOWTIE_REST_ENDPOINTS.importBowtieStatus}/`, {
        method: 'GET',
        credentials: 'same-origin'
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        return jsonData
    })
}
